import React, { Component, Fragment } from "react";
import CustomForm from "../../../libraries/form";

import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import _ from "lodash";
import { Button } from "reactstrap";
import Dialog from "../../../libraries/Dialog";
import Breadcrumbs from "../../../libraries/Breadcrumbs";
import { OpenConfirmationDialog, confirmationDialogWarningMessage } from "../../../libraries/ConfirmationDialog";
import { hosEntryFormSchema } from "./schemas/hosEntryFormSchema";
import { hosLocationFormSchema } from "../HosLocationManager/schemas/hosLocationFormSchema";

import { themeService } from "theme/service/activeTheme.service";
import { ButtonStyle, CommonModalStyle } from "style/basic/commonControls";
import { languageService } from "../../../Language/language.service";

import moment from "moment";
import { dataFormatters } from "../../../utils/dataFormatters";
import { ToastService } from "../../../utils/toastify";

import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import { arrayToSelectOptions } from "../../../utils/arrayToSelectOptions";
import HosValidators from "../Helper/HosValidators";
import HosCalendarView from "../Helper/HosCalendarView";
import "./style.css";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "reduxCURD/actions";
import SpinnerLoader from "../../Common/SpinnerLoader";
import AddHosRecordReviewPhase from "./AddHosRecordReviewPhase";
import AddHosRecordDraftPhase from "./AddHosRecordDraftPhase";
import ViewSubmittedHosRecord from "./ViewSubmittedHosRecord";
import { HOS_RECORD_ENTRY_PHASE } from "./constants";
import SelectHosInputMethodPhase from "./SelectHosInputMethodPhase";
import { getDateFromDateTimeAndTimezone } from "../Helper/HosTemplateEntryValidators";

// dont allow the user to open HOS date before the configured start date (done)
// Hide HOS for the user until it is opened for the user by a supervisor (done)
// Even admin must first define the start/effective date in order to start filling the hos (done)

class MyHoursOfService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hosCurrentMonth: {
        year: null,
        month: null,
        data: {
          hosRecords: [],
          latestHosRecord: null,
        },
      },
      openAddEditHosEntryForm: false,
      addEditHosEntryData: {},
      addEditHosEntryFormSchema: null,
      addEditHosEntryFormState: null,
      hosReportingPeriodDate: null,
      selectedHosEntryIndex: -1,
      confirmationDialog: null,
      offDays: [],
      prevHosRecords: [],
      currentHosRecords: [],
      currentHosRecordsWithViolations: [],
      pendingChanges: false,
      hosRecordEntryPhase: HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase,
      sessionLoaded: false,
      showloader: false,
      hosLocationsState: [],

      openAddEditLocationForm: false,
      addEditLocationData: {},
      addEditLocationFormState: null,
    };
    this.compileHosEntryFormSchema = this.compileHosEntryFormSchema.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
    this.getMinDateForForm = this.getMinDateForForm.bind(this);

    this.closeDialog = this.closeDialog.bind(this);
    this.openCreateHosEntryForm = this.openCreateHosEntryForm.bind(this);
    this.openEditOrDeleteHosEntryForm = this.openEditOrDeleteHosEntryForm.bind(this);
    this.addUpdateOrDeleteHosEntry = this.addUpdateOrDeleteHosEntry.bind(this);

    this.closeLocationDialog = this.closeLocationDialog.bind(this);
    this.openAddLocationForm = this.openAddLocationForm.bind(this);
    this.addRestLocation = this.addRestLocation.bind(this);
    this.stateChangeReducer = this.stateChangeReducer.bind(this);
    this.resetCurrentPeriod = this.resetCurrentPeriod.bind(this);

    this.setShowLoader = this.setShowLoader.bind(this);
    this.updateLocationSchema = this.updateLocationSchema.bind(this);
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }

  componentDidMount() {
    const { getEntryTemplates } = this.props;
    const { hosLocationsWithAllDetails } = this.context;
    this.setState({ hosLocationsState: hosLocationsWithAllDetails });
    getEntryTemplates && getEntryTemplates();
  }

  componentDidUpdate(prevProps, prevState) {
    const { actionType, entryTemplateActionType, MyHoursOfService } = this.props;
    const { hosRecordEntryPhase } = this.state;
    const { hosLocationsWithAllDetails } = this.context;

    if (hosLocationsWithAllDetails !== prevState.hosLocationsState) {
      console.log("LOC update function");
      this.updateLocationSchema();
      this.setState({ hosLocationsState: hosLocationsWithAllDetails });
    }

    if (actionType !== prevProps.actionType) {
      if (
        actionType === "MYHOURSOFSERVICE_CREATE_REQUEST" ||
        actionType === "MYHOURSOFSERVICE_READ_REQUEST" ||
        actionType === "MYHOURSOFSERVICE_UPDATE_REQUEST"
      ) {
        this.setShowLoader(true);
      } else if (actionType === "MYHOURSOFSERVICE_CREATE_SUCCESS") {
        this.setShowLoader(false);
        if (MyHoursOfService && MyHoursOfService["error"]) {
          const { error } = MyHoursOfService;
          ToastService.Error(`${languageService("Error")}:`, error); // An informative error message received from the server
        } else {
          this.stateChangeReducer(HOS_RECORD_ENTRY_PHASE[hosRecordEntryPhase].nextPhase, MyHoursOfService);
        }
      } else if (actionType === "MYHOURSOFSERVICE_READ_SUCCESS") {
        this.stateChangeReducer("received-hos-data", MyHoursOfService);
        this.setShowLoader(false);
      } else if (actionType === "MYHOURSOFSERVICE_UPDATE_SUCCESS") {
        if (MyHoursOfService && MyHoursOfService["error"]) {
          const { error } = MyHoursOfService;
          ToastService.Error(`${languageService("Error")}:`, error); // An informative error message received from the server
        } else {
          this.stateChangeReducer("save-hos-for-date-success", MyHoursOfService);
        }
        this.setShowLoader(false);
      } else if (
        actionType === "MYHOURSOFSERVICE_CREATE_FAILURE" ||
        actionType === "MYHOURSOFSERVICE_READ_FAILURE" ||
        actionType === "MYHOURSOFSERVICE_UPDATE_FAILURE"
      ) {
        this.setShowLoader(false);
      }
    }

    if (entryTemplateActionType !== prevProps.entryTemplateActionType) {
      if (entryTemplateActionType === "ENTRYTEMPLATES_READ_REQUEST") {
        this.setShowLoader(true);
      } else if (actionType === "ENTRYTEMPLATES_READ_SUCCESS") {
        this.setShowLoader(false);
      } else if (actionType === "ENTRYTEMPLATES_READ_FAILURE") {
        this.setShowLoader(false);
      }
    }
  }

  resetCurrentPeriod() {
    this.setState({
      openAddEditHosEntryForm: false,
      addEditHosEntryData: {},
      addEditHosEntryFormState: null,
      selectedHosEntryIndex: -1,
      confirmationDialog: null,
      prevHosRecords: [],
      currentHosRecords: [],
      pendingChanges: false,
      sessionLoaded: false,
    });
  }

  // load Select Options for various form fields, and add minDate for date fields
  compileHosEntryFormSchema(minDate) {
    const { getHosLocationsSelectOptions, hosDutyTypes, hosServiceTypes } = this.context;

    let changeData = {
      startLocCode: {
        selectOptions: getHosLocationsSelectOptions(),
      },
      endLocCode: {
        selectOptions: getHosLocationsSelectOptions(),
      },
      dutyType: {
        selectOptions: arrayToSelectOptions(hosDutyTypes.filter((type) => type !== "Off Duty")),
      },
      serviceType: {
        selectOptions: arrayToSelectOptions(hosServiceTypes),
      },
      startDate: {
        minDate: moment(minDate).clone(),
        maxDate: moment(minDate).clone().add(1, "day"),
      },
      endDate: {
        minDate: moment(minDate).clone(),
        maxDate: moment(minDate).clone().add(2, "day"),
      },
      pointDate: {
        minDate: moment(minDate).clone(),
        maxDate: moment(minDate).clone().add(1, "day"),
      },
    };

    let formSchema = updateShortSchema(_.cloneDeep(hosEntryFormSchema), changeData);
    return formSchema;
  }

  closeDialog() {
    this.setState({ openAddEditHosEntryForm: false, addEditHosEntryData: {}, addEditHosEntryFormState: null, selectedHosEntryIndex: -1 });
  }

  closeConfirmationDialog() {
    this.setState({
      confirmationDialog: null,
    });
  }

  // get minDate to be allowed in the HOS entry form to be available for selection
  getMinDateForForm(additionalDate = null) {
    const { hosReportingPeriodDate, hosCurrentMonth, currentHosRecords } = this.state;
    const { latestHosRecord } = hosCurrentMonth.data;
    const { timezone, effectiveDate } = this.props;
    // configure the oldest date that can be selected in startDate and endDate
    let minDates = [moment.tz(hosReportingPeriodDate, timezone).startOf("day"), moment.tz(effectiveDate, timezone).startOf("day")];
    if (latestHosRecord) {
      minDates.push(moment.tz(latestHosRecord.endDate, timezone));
    }

    if (additionalDate) {
      minDates.push(moment.tz(additionalDate, timezone));
    } else if (currentHosRecords.length > 0) {
      const lastRecordInCurrHosRecords = currentHosRecords[currentHosRecords.length - 1];
      minDates.push(moment.tz(lastRecordInCurrHosRecords.endDate, lastRecordInCurrHosRecords.timezone));
    }
    return moment.max(minDates).clone();
  }

  /**
   * opens Hos Entry form in create state
   */
  openCreateHosEntryForm() {
    const { hq, timezone } = this.props;
    const { currentHosRecords } = this.state;
    // by default, we expect the user to enter the start date and time from the very start of the 24-hour day and end date to also be the same as the start date

    const minDate = this.getMinDateForForm();
    let initialData = {
      startDate: moment.tz(minDate.clone(), timezone),
      endDate: moment.tz(minDate.clone(), timezone),
      pointDate: moment.tz(minDate.clone(), timezone),
      startLocCode: hq ? hq : null,
      endLocCode: hq ? hq : null,
    };
    if (currentHosRecords.length > 0) {
      const lastRecord = currentHosRecords[currentHosRecords.length - 1];
      // check if the last entry in hos has all required date and time values present
      if (!HosValidators.validateMinCriteriaForHosRecord(lastRecord, true)) {
        return;
      }

      initialData = {
        dutyType: lastRecord.dutyType,
        startDate: moment.tz(lastRecord.endDate, timezone),
        endDate: moment.tz(lastRecord.endDate, timezone),
        pointDate: moment.tz(lastRecord.endDate, timezone),
        startLocCode: lastRecord.endLocCode,
        endLocCode: lastRecord.endLocCode,
      };
    }
    this.setState({
      openAddEditHosEntryForm: true,
      addEditHosEntryFormSchema: this.compileHosEntryFormSchema(minDate),
      addEditHosEntryData: initialData,
      addEditHosEntryFormState: "create",
    });
  }

  /**
   * opens Hos Entry form in edit, partialEdit or delete states
   * @param {number} index index of the selected Hos entry from the currentHosRecords
   * @param {"edit" | "partialEdit" | "delete"} formState the state in which we need to open the form
   */
  openEditOrDeleteHosEntryForm(index, formState) {
    const { currentHosRecords } = this.state;

    if (index < currentHosRecords.length) {
      let selectedRow = { ...currentHosRecords[index] };

      if (selectedRow.dutyType === "Interrupted Rest") {
        selectedRow.pointDate = selectedRow.startDate;
      }

      this.setState({
        selectedHosEntryIndex: index,
        addEditHosEntryFormSchema: this.compileHosEntryFormSchema(this.getMinDateForForm(selectedRow.startDate)),
        openAddEditHosEntryForm: true,
        addEditHosEntryData: selectedRow,
        addEditHosEntryFormState: formState,
      });
    }
  }

  /**
   * adds or updates currentHosRecords based on the submission
   * @param {object} submission submission is an object with form fields property which contains all the submitted values by the form
   * @param {"add" | "update" | "delete"} action the action defines whether we want to "add" a new hos entry, "update" an existing hos entry or "delete" an existing hos entry
   */
  addUpdateOrDeleteHosEntry(submission, action) {
    const { getActivityTypeOpt2BasedOnCode, getHosLocationOpt2BasedOnCode } = this.context;
    const { currentHosRecords, selectedHosEntryIndex, hosCurrentMonth } = this.state;
    const { data } = hosCurrentMonth;
    if ((action === "update" || action === "delete") && selectedHosEntryIndex === -1 && selectedHosEntryIndex >= currentHosRecords.length) {
      console.log("Invalid pointers");
      console.log(this.state);
      return;
    }
    let updatedCurrentHosRecords = [...currentHosRecords];
    if (action === "delete") {
      updatedCurrentHosRecords.splice(selectedHosEntryIndex, 1);
    } else {
      const { timezone } = this.props;
      let fields = {
        ...submission.fields,
        timezone: timezone,
      };

      let lastRecord = null;
      if (action === "update" && selectedHosEntryIndex > 0) {
        // load last Record for comparison
        lastRecord = currentHosRecords[selectedHosEntryIndex - 1];
      } else if (action === "add" && currentHosRecords.length > 0) {
        // load last Record for comparison
        lastRecord = currentHosRecords[currentHosRecords.length - 1];
      }

      if (!lastRecord) {
        lastRecord = data.latestHosRecord;
      }

      if (fields.dutyType === "Interrupted Rest") {
        fields = {
          ...fields,
          startDate: submission.fields.pointDate,
          endDate: new Date(submission.fields.pointDate),
        };
        delete fields["pointDate"];
        if (
          !HosValidators.validateHosRecordForDuplicateInterruptedRest(fields, lastRecord, true) ||
          !HosValidators.validateHosRecordForDuplicateInterruptedRest(fields, data.latestHosRecord, true) ||
          !HosValidators.validateHosRecordForInterruptedRestWithoutGap(fields, lastRecord, true) ||
          !HosValidators.validateHosRecordForInterruptedRestWithoutGap(fields, data.latestHosRecord, true)
        ) {
          return;
        }
      } else {
        fields = {
          ...fields,
          activityType: getActivityTypeOpt2BasedOnCode(submission.fields.activityTypeCode),
          startLoc: getHosLocationOpt2BasedOnCode(submission.fields.startLocCode),
          endLoc: getHosLocationOpt2BasedOnCode(submission.fields.endLocCode),
        };
      }

      if (
        /*check if required values are present*/ (HosValidators.validateMinCriteriaForHosRecord(fields, false) &&
          /*check if the entered values are non-conflicting*/ !HosValidators.validateHosRecordForConflicts(fields, lastRecord, true)) ||
        /* check for location conflicts*/ !HosValidators.validateHosRecordForLocationConflict(fields, lastRecord, true) ||
        /*check if the entered values are for more than 24 hours*/ !HosValidators.validateHosRecordForMoreThan24Hours(fields, true) ||
        /* check if the entered values are conflicting with the latestHosRecord*/ (data.latestHosRecord &&
          !HosValidators.validateHosRecordForConflicts(fields, data.latestHosRecord, true))
      )
        // todo: validate if the entered values are before the HOS configured effective date. do we need timezone with the effective Date

        // todo: add validation on the server to avoid submitted HOS records in the future
        return;
      if (fields.serviceType === "Meal") {
        if (!HosValidators.validateMealDuration(fields, true)) {
          return false;
        }
      }
      if (action === "update") {
        // update record
        updatedCurrentHosRecords[selectedHosEntryIndex] = { ...fields };
      } else if (action === "add") {
        // add record
        updatedCurrentHosRecords = [...updatedCurrentHosRecords, fields];
      }
    }

    this.setState({
      currentHosRecords: updatedCurrentHosRecords,
      selectedHosEntryIndex: -1,
      addEditHosEntryData: {},
      addEditHosEntryFormState: null,
      openAddEditHosEntryForm: false,
      pendingChanges: true,
    });
  }

  stateChangeReducer(action, data) {
    const { getMyHoursOfService, updateMyHoursOfService, createMyHoursOfService } = this.props;
    const { pendingChanges } = this.state;
    const { hosCurrentMonth, hosReportingPeriodDate } = this.state;
    const { currentHosRecords, currentHosRecordsWithViolations } = this.state;
    const { timezone } = this.props;
    const missingValidationReasons = currentHosRecordsWithViolations
      .filter((record) => Array.isArray(record.violations))
      .map((record) => record.violations)
      .flat()
      .map((violation) => violation.reason)
      .reduce((missing, reason) => {
        if (!reason) {
          missing = true;
        }
        return missing;
      }, false);
    switch (action) {
      case "load-hos-month-data":
        const { month, year } = data;
        this.setState({
          hosCurrentMonth: {
            year: year,
            month: month,
            data: {
              hosRecords: [],
              latestHosRecord: null,
            },
          },
        });
        this.props.stateRetention.set("calendarSettings", {
          year: year,
          month: parseInt(month) - 1,
        });
        // fetch monthly hos data records from the server
        getMyHoursOfService && getMyHoursOfService(`entry/minisearch/${year}/${month}`);
        break;
      case "load-hos-for-date":
        const { date, submitted } = data;
        // get prevHosRecords
        const selectedDayStart = moment.tz(date, timezone).startOf("day");
        const selectedDayEnd = moment.tz(date, timezone).endOf("day");
        let prevRecords = hosCurrentMonth.data.hosRecords
          .filter((record) => record.dutyType !== "Off Duty") // consider On Duty only
          // duties starting on current or previous days i.e. after 23:59:59
          .filter((record) => !moment.tz(record.startDate, timezone).isAfter(selectedDayEnd))
          .sort((a, b) => new Date(a.endDate) - new Date(b.endDate)); // sort

        // duty is starting on the next day i.e. after 23:59:59
        let lastDayRecords = prevRecords.filter((record) => !moment.tz(record.endDate, timezone).isSameOrBefore(selectedDayStart));
        if (submitted || lastDayRecords.length > 0) {
          prevRecords = lastDayRecords;
        } else {
          prevRecords = prevRecords.slice(-1); // get last element only
        }

        this.setState({
          hosReportingPeriodDate: date,
          openAddEditHosEntryForm: false,
          addEditHosEntryData: {},
          addEditHosEntryFormState: null,
          selectedHosEntryIndex: -1,
          confirmationDialog: null,
          prevHosRecords: prevRecords,
          currentHosRecords: [],
          currentHosRecordsWithViolations: [],
          pendingChanges: false,
          sessionLoaded: true,
          hosRecordEntryPhase: submitted ? HOS_RECORD_ENTRY_PHASE.PRESUBMITTED.currPhase : HOS_RECORD_ENTRY_PHASE.VIEWONLY.currPhase,
        });

        // fetch hos data records for the date from the server
        // getMyHoursOfService && getMyHoursOfService(dataFormatters.stringifyDateInYYYYMMDD(date));
        break;
      case "received-hos-data":
        // multiple records are received
        if (data && Array.isArray(data.hosRecords)) {
          // store monthly hos data records received

          const offDays = data.hosRecords
            .filter((record) => record.dutyType === "Off Duty")
            .map((record) => {
              let startDate = moment.tz(record.startDate, record.timezone);
              let endDate = moment.tz(record.endDate, record.timezone);
              let days = [];
              while (!startDate.isSameOrAfter(endDate)) {
                days.push({ date: startDate.clone(), activityType: record.activityType });
                startDate.add(1, "day");
              }
              return days;
            })
            .flat();

          this.setState({
            hosCurrentMonth: {
              ...hosCurrentMonth,
              data: _.cloneDeep(data),
            },
            offDays: offDays,
          });
        }
        break;

      // case "save-hos-for-date":
      //   // save changes to the server
      //   updateMyHoursOfService && updateMyHoursOfService(currentHosRecords, `addHosRecords/${formattedServiceDate}`);
      //   break;
      // case HOS_RECORD_ENTRY_PHASE.VIEWONLY.currPhase:
      //   // validate hos records on the server
      //   this.setState({
      //     hosRecordEntryPhase: action,
      //     currentHosRecordsWithViolations: [],
      //   });
      //   createMyHoursOfService && createMyHoursOfService(currentHosRecords, "hosRecords", `/entry/validate`);
      //   break;
      case HOS_RECORD_ENTRY_PHASE.REVIEWINPROGRESS.currPhase:
        // validate hos records on the server
        this.setState({
          hosRecordEntryPhase: action,
          currentHosRecordsWithViolations: [],
        });
        createMyHoursOfService && createMyHoursOfService(currentHosRecords, "hosRecords", `/entry/validate`);
        break;
      case HOS_RECORD_ENTRY_PHASE.REVIEW.currPhase:
        if (!data || !Array.isArray(data.hosRecords) || data.hosRecords.length !== currentHosRecords.length) {
          this.setState({
            hosRecordEntryPhase: HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase,
          });
          ToastService.Error(`${languageService("Error")}: `, "HOS records invalidated!");
        } else {
          this.setState({
            hosRecordEntryPhase: action,
            currentHosRecordsWithViolations: data && Array.isArray(data.hosRecords) ? data.hosRecords : [],
          });
        }

        break;
      case HOS_RECORD_ENTRY_PHASE.SUBMITINPROGRESS.currPhase:
        // submit hos
        if (missingValidationReasons) {
          ToastService.Error(`${languageService("Error")}: `, languageService("Please provide reason for all the violations."));
        } else {
          createMyHoursOfService && createMyHoursOfService(currentHosRecordsWithViolations, "hosRecords", `/entry/submit`);
          this.setState({
            hosRecordEntryPhase: action,
          });
        }
        break;
      case HOS_RECORD_ENTRY_PHASE.SUBMITTED.currPhase:
        this.resetCurrentPeriod();
        this.stateChangeReducer("load-hos-month-data", {
          year: hosCurrentMonth.year,
          month: hosCurrentMonth.month,
        });
        break;

      case "discard-session":
        if (pendingChanges) {
          this.setState({
            confirmationDialog: (
              <OpenConfirmationDialog
                title={`${languageService("Confirm Discard")}`}
                message={`${languageService("Are you sure you want to discard unsaved changes for current reporting period?")}`}
                displayAddInfo={confirmationDialogWarningMessage(`${languageService("Note: Unsaved changes will be permanently lost!")}`)}
                action="confirm-discard-session"
                cancelCallback={this.closeConfirmationDialog}
                confirmCallback={this.stateChangeReducer}
              />
            ),
          });
        } else {
          this.resetCurrentPeriod();
        }
        break;
      case "confirm-discard-session":
        this.resetCurrentPeriod();
        break;
    }
  }

  closeLocationDialog() {
    this.setState({ openAddEditLocationForm: false, addEditLocationData: {}, addEditLocationFormState: null });
  }

  openAddLocationForm() {
    this.setState({
      openAddEditLocationForm: true,
      addEditLocationData: {},
      addEditLocationFormState: "create",
    });
  }

  addRestLocation(submission) {
    let { fields } = submission;
    // add new rest location to the server
    const { createLookup, hosLocationsWithAllDetails } = this.context;
    const newLocation = { listName: "hosLocations", ..._.pick(fields, ["description"]) };
    newLocation.opt2 = { ...fields };
    createLookup && createLookup(newLocation, hosLocationsWithAllDetails);

    this.setState({
      addEditLocationData: {},
      openAddEditLocationForm: false,
      addEditLocationFormState: null,
    });
  }

  updateLocationSchema() {
    const minDate = this.getMinDateForForm();

    this.setState({
      addEditHosEntryFormSchema: this.compileHosEntryFormSchema(minDate),
    });
  }

  render() {
    const { effectiveDate, timezone, entryTemplates } = this.props;
    const { getServiceTypeBasedOnDutyType, getActivityTypeSelectOptionsBasedOnServiceType } = this.context;
    const {
      openAddEditHosEntryForm,
      addEditHosEntryData,
      addEditHosEntryFormSchema,
      addEditHosEntryFormState,
      openAddEditLocationForm,
      addEditLocationData,
      addEditLocationFormState,
    } = this.state;
    const { hosCurrentMonth } = this.state;
    const { hosReportingPeriodDate } = this.state;
    const { offDays, prevHosRecords, currentHosRecords, currentHosRecordsWithViolations } = this.state;
    const { sessionLoaded, hosRecordEntryPhase } = this.state;
    const formattedServiceDate = dataFormatters.stringifyDateInYYYYMMDD(hosReportingPeriodDate);

    const noHosRecordsAdded = currentHosRecords.length === 0;
    const commingledRecords = currentHosRecords.filter((record) => record.serviceType === "Commingled Service");
    const { latestHosRecord } = hosCurrentMonth.data;

    const { confirmationDialog } = this.state;

    let minDateForGraphicalView = hosReportingPeriodDate;
    if (prevHosRecords.length > 0) {
      minDateForGraphicalView = moment.min(moment(hosReportingPeriodDate), moment(prevHosRecords[0].endDate).add(1, "day"));
    }
    const noSupervisor =
      currentHosRecordsWithViolations
        .filter((r) => Array.isArray(r.violations))
        .map((r) => r.violations)
        .flat()
        .filter((v) => !v.supervisor).length > 0;
    const currViolations = currentHosRecordsWithViolations
      .map((record, i) => ({ ...record, recordIndex: i }))
      .filter((record) => Array.isArray(record.violations) && record.violations.length > 0)
      .map((record) =>
        record.violations.map((violation, j) => ({
          recordIndex: record.recordIndex,
          violationIndex: j,
          dutyType: record.dutyType,
          startDate: record.startDate,
          startLoc: record.startLoc ? record.startLoc.description : "",
          endDate: record.endDate,
          endLoc: record.endLoc ? record.endLoc.description : "",
          timezone: record.timezone,
          issueText: violation.issueText,
          reason: violation.reason,
          tableFields: [
            { key: languageService("Issue"), value: languageService(violation.issueText) },
            { key: languageService("Duty Type"), value: record.dutyType },
            {
              key: languageService("Start Date & Time"),
              value: dataFormatters.dateTimeFormatterWithTimezone(record.startDate, record.timezone, true),
            },
            { key: languageService("Start Location"), value: record.startLoc ? record.startLoc.description : "" },
            {
              key: languageService("End Date & Time"),
              value: dataFormatters.dateTimeFormatterWithTimezone(record.endDate, record.timezone, true),
            },
            { key: languageService("End Location"), value: record.endLoc ? record.endLoc.description : "" },
            {
              key: languageService("Supervisor"),
              value: violation.supervisor ? `${violation.supervisor.name} (${violation.supervisor.email})` : "N/A",
            },
            {
              key: languageService("Reason (to be filled by the Supervisor)"),
              input: !noSupervisor,
              editMode: false,
              value: violation.reason ? violation.reason : "",
            },
          ],
        })),
      )
      .flat();
    let dialogMessages = [];
    noSupervisor &&
      dialogMessages.push({
        message: languageService("You need a Supervisor to add reason for violations."),
        type: languageService("Error"),
      });
    currViolations.length > 0 &&
      dialogMessages.push({
        message: languageService("One or more of your reported periods is in violation of FRA Hours of Service regulations."),
        type: languageService("Info"),
      });

    return (
      <div>
        <SpinnerLoader spinnerLoading={this.state.showloader} />
        <HosCalendarView
          getHosRecordsForMonth={(monthName, year) => {
            this.stateChangeReducer("load-hos-month-data", {
              month: moment().month(monthName).format("M"), // 1-12
              year: year,
            });
          }}
          calendarYear={this.props.stateRetention.calendarSettings.year}
          calendarMonth={this.props.stateRetention.calendarSettings.month}
          offDays={offDays}
          effectiveDate={effectiveDate}
          hosRecords={hosCurrentMonth.data.hosRecords}
          latestHosRecord={hosCurrentMonth.data.latestHosRecord}
          timezone={timezone}
          openHosDataDialog={(data) => this.stateChangeReducer("load-hos-for-date", data)}
        />
        {confirmationDialog}
        {sessionLoaded ? (
          <Dialog
            className={"my-hos-records-dialog"}
            title={`${languageService("Hours of Service records for")} '${formattedServiceDate}'`}
            breadcrumbs={
              hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.PRESUBMITTED.currPhase ? null : (
                <Breadcrumbs
                  phases={[HOS_RECORD_ENTRY_PHASE.VIEWONLY, HOS_RECORD_ENTRY_PHASE.DRAFT, HOS_RECORD_ENTRY_PHASE.REVIEW]}
                  currPhase={languageService(hosRecordEntryPhase)}
                />
              )
            }
            messages={dialogMessages}
            isOpen={true}
            body={
              <Fragment>
                <SpinnerLoader spinnerLoading={this.state.showloader} />
                {(hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase ||
                  hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.DRAFT.nextPhase) && (
                  <AddHosRecordDraftPhase
                    effectiveDate={effectiveDate}
                    timezone={timezone}
                    hosReportingPeriodDate={hosReportingPeriodDate}
                    prevHosRecords={prevHosRecords}
                    currentHosRecords={currentHosRecords}
                    commingledRecords={commingledRecords}
                    openCreateHosEntryForm={this.openCreateHosEntryForm}
                    openEditOrDeleteHosEntryForm={this.openEditOrDeleteHosEntryForm}
                    latestHosRecord={latestHosRecord}
                  />
                )}

                {(hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.REVIEW.currPhase ||
                  hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.REVIEW.nextPhase) && (
                  <AddHosRecordReviewPhase
                    effectiveDate={effectiveDate}
                    hosReportingPeriodDate={minDateForGraphicalView}
                    timezone={timezone}
                    latestHosRecord={latestHosRecord}
                    prevHosRecords={prevHosRecords}
                    currentHosRecords={currentHosRecordsWithViolations}
                    commingledRecords={commingledRecords}
                    complianceIssues={currViolations}
                    addReason={(recordIndex, violationIndex, reason) => {
                      this.setState({
                        currentHosRecordsWithViolations: currentHosRecordsWithViolations.map((r, i) => {
                          if (i === recordIndex) {
                            return {
                              ...r,
                              violations: r.violations.map((v, j) => {
                                if (j === violationIndex) {
                                  return { ...v, reason: reason };
                                }
                                return v;
                              }),
                            };
                          }
                          return r;
                        }),
                      });
                    }}
                  />
                )}

                {hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.VIEWONLY.currPhase && (
                  <SelectHosInputMethodPhase
                    timezone={timezone}
                    entryTemplates={entryTemplates}
                    prevHosRecords={prevHosRecords}
                    hosReportingPeriodDate={hosReportingPeriodDate}
                    latestHosRecord={latestHosRecord}
                    selectInputMode={(templateId = -1) => {
                      if (templateId === -1) {
                        // continue in draft mode
                        this.setState({
                          hosRecordEntryPhase: HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase,
                        });
                      } else {
                        let template = entryTemplates.find((t) => t._id === templateId);
                        if (template) {
                          let records = [...template.hosRecords].map(({ _id, startDate, endDate, startTime, endTime, ...r }) => ({
                            ...r,
                            timezone: timezone,
                            startDate: getDateFromDateTimeAndTimezone(
                              hosReportingPeriodDate,
                              startTime,
                              timezone,
                              startDate === "Next Day",
                            ),
                            endDate: getDateFromDateTimeAndTimezone(hosReportingPeriodDate, endTime, timezone, endDate === "Next Day"),
                          }));
                          const firstNewRecord = records[0];
                          const lastPrevRecord = prevHosRecords[prevHosRecords.length - 1];
                          let isValid = true;
                          if (!firstNewRecord || !lastPrevRecord) {
                            isValid = true;
                          } else if (moment(firstNewRecord.startDate).isBefore(moment(lastPrevRecord.endDate))) {
                            ToastService.Error(
                              `${languageService("Error")}:`,
                              languageService("Cannot load the template due to overlapping activities."),
                            );
                            isValid = false;
                          } else if (!HosValidators.validateHosRecordForLocationConflict(firstNewRecord, lastPrevRecord, true)) {
                            isValid = false;
                          } else if (!HosValidators.validateHosRecordForConflicts(firstNewRecord, lastPrevRecord, true)) {
                            isValid = false;
                          }
                          if (isValid) {
                            this.setState({
                              hosRecordEntryPhase: HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase,
                              currentHosRecords: records,
                              currentHosRecordsWithViolations: [],
                              pendingChanges: true,
                            });
                          }
                        }
                      }
                    }}
                  />
                )}

                {hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.PRESUBMITTED.currPhase && (
                  <ViewSubmittedHosRecord
                    effectiveDate={effectiveDate}
                    timezone={timezone}
                    prevHosRecords={prevHosRecords}
                    currentHosRecords={currentHosRecords}
                    hosReportingPeriodDate={hosReportingPeriodDate}
                    latestHosRecord={latestHosRecord}
                  />
                )}

                {openAddEditHosEntryForm && (
                  <CustomForm
                    mode="dialog"
                    currState={addEditHosEntryFormState}
                    fieldsData={addEditHosEntryData}
                    formSchema={addEditHosEntryFormSchema}
                    closeDialog={this.closeDialog}
                    parentRef={{
                      updateHosEntry: (submission) => this.addUpdateOrDeleteHosEntry(submission, "update"),
                      addHosEntry: (submission) => this.addUpdateOrDeleteHosEntry(submission, "add"),
                      confirmDeleteHosEntry: (submission) => this.addUpdateOrDeleteHosEntry(submission, "delete"),
                      getServiceTypeOptionsBasedOnDutyType: (type) => {
                        return arrayToSelectOptions(getServiceTypeBasedOnDutyType(type));
                      },
                      getActivityTypeOptionsBasedOnServiceType: (type) => {
                        return getActivityTypeSelectOptionsBasedOnServiceType(type);
                      },
                      addHosEntryLocation: () => this.openAddLocationForm(),
                    }}
                  />
                )}

                {openAddEditLocationForm && (
                  <CustomForm
                    mode="dialog"
                    currState={addEditLocationFormState}
                    fieldsData={addEditLocationData}
                    formSchema={hosLocationFormSchema}
                    closeDialog={this.closeLocationDialog}
                    parentRef={{
                      addRestLocation: this.addRestLocation,
                    }}
                  />
                )}
              </Fragment>
            }
            footer={
              <React.Fragment>
                {HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase === hosRecordEntryPhase && HOS_RECORD_ENTRY_PHASE.DRAFT.prevPhase && (
                  <Button
                    style={themeService(ButtonStyle.commonButton)}
                    onClick={() =>
                      this.setState({
                        currentHosRecords: [],
                        currentHosRecordsWithViolations: [],
                        pendingChanges: false,
                        hosRecordEntryPhase: HOS_RECORD_ENTRY_PHASE.VIEWONLY.currPhase,
                      })
                    }
                  >
                    {languageService("Back")}
                  </Button>
                )}
                {HOS_RECORD_ENTRY_PHASE.REVIEW.currPhase === hosRecordEntryPhase && HOS_RECORD_ENTRY_PHASE.REVIEW.prevPhase && (
                  <Button
                    style={themeService(ButtonStyle.commonButton)}
                    onClick={() =>
                      this.setState({
                        hosRecordEntryPhase: HOS_RECORD_ENTRY_PHASE.REVIEW.prevPhase,
                        currentHosRecordsWithViolations: [],
                      })
                    }
                  >
                    {languageService("Back")}
                  </Button>
                )}
                {HOS_RECORD_ENTRY_PHASE[hosRecordEntryPhase] &&
                  HOS_RECORD_ENTRY_PHASE[hosRecordEntryPhase].nextPhase &&
                  HOS_RECORD_ENTRY_PHASE[hosRecordEntryPhase].nextTitle && (
                    <Button
                      style={themeService(ButtonStyle.commonButton)}
                      disabled={hosRecordEntryPhase === HOS_RECORD_ENTRY_PHASE.DRAFT.currPhase && noHosRecordsAdded}
                      onClick={() => this.stateChangeReducer(HOS_RECORD_ENTRY_PHASE[hosRecordEntryPhase].nextPhase)}
                    >
                      {languageService(HOS_RECORD_ENTRY_PHASE[hosRecordEntryPhase].nextTitle)}
                    </Button>
                  )}
                <Button onClick={() => this.stateChangeReducer("discard-session")} style={themeService(ButtonStyle.commonButton)}>
                  {languageService("Close")}
                </Button>
              </React.Fragment>
            }
            closeDialog={() => {
              // openCallback(false)
            }}
          />
        ) : null}
      </div>
    );
  }
}

MyHoursOfService.contextType = FixedAppLookupsContext;

const getEntryTemplates = curdActions.getEntryTemplates;

let variableList = {
  entryTemplateReducer: {
    entryTemplates: [],
  },
};
let reducers = ["entryTemplateReducer"];

let actionOptions = {
  read: true,
  create: true,
  update: true,
  delete: true,
  others: {
    getEntryTemplates,
  },
};

const MyHoursofServiceContainer = CRUDFunction(
  MyHoursOfService,
  "MyHoursOfService",
  actionOptions,
  variableList,
  reducers,
  "hoursofservice",
);

export default MyHoursofServiceContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/index.jsx